export default __webpack_public_path__ + "Darga_SWE_Resume.2xbXt.pdf";